<div *ngIf="distance > 0"
     class="ts-small">
  <div class="d-flex ion-align-items-center gap-1 w-100">

    <div class="ts-small-bold text-neutral-400">
      {{ distanceLabel }}
    </div>

    <div>·</div>

    <div class="d-flex ion-align-items-center gap-1">
      <div class="ts-small-bold text-neutral-400">{{minutes}} min</div>
    </div>

    <div>·</div>

    <div class="text-neutral-400">
      <span style="font-size: 20px" class="material-symbols-outlined">{{ directionType == 'walk' ? 'directions_walk': 'directions_car' }}</span>
    </div>


  </div>
</div>
